const riot = require('riot');

riot.tag2('page-faq', '<div class="h-full f fclm"> <div data-is="module-header" title="ヘルプ" back="{true}"></div> <div class="s-full rounded-12 overflow-scroll" ref="body"> <div class="f fclm container"> <div data-is="module-faq"></div> </div> </div> <div class="flex-fixed w-full s-show" if="{!app.utils.isKeyboardOpen()}" data-is="module-tabbar"></div> </div>', 'page-faq,[data-is="page-faq"]{display:block}', '', function(opts) {
    this.head = () => {
      return {
        title: `ヘルプ | ${spat.config.head.ogp.site_name}`,
      };
    };
});